import { createPutAsyncSlice } from '@sonar-software/xuder';
import { getJiraSummarySlice } from './summary/get';
import { putJiraCredentials } from '@api';

export const putJiraCredentialsSlice = createPutAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary ]
	},
	name: 'jiraCredentials',
	receive: false,
	request: true,
	requestHandler: putJiraCredentials
});
